<template>
  <div class="ts-w-full">
    <div v-for="(subBlock, subBlockName) in dataFooter" class="ts-mb-10 ts-relative">
      <div class="ts-mb-1 ts-w-full subblock-name">
        <span class="ts-whitespace-no-wrap ts-text-lg ts-font-semibold text-primary subblock-name__text">{{ subBlockName }}</span>
      </div>
      <div class="ts-px-3 ts-pb-3 ts-pt-3 ts-border ts-border-gray-200 ts-rounded">
        <div class="ts-flex ts--mx-2">
          <div class="ts-w-1/2 ts-px-2">
            <div class="ts-w-full" v-if="subBlock.L">
              <div class="ts-flex ts--mx-2" v-for="item in subBlock.L">
                <span class="ts-w-3/6 ts-px-2 ts-text-gray-800 ts-font-semibold ts-leading-loose">{{
                  item.dispay_name
                }}</span>
                <span class="ts-whitespace-no-wrap ts-w-3/6 ts-px-2 ts-text-gray-700 ts-leading-loose">{{ item.field_value }}</span>
              </div>
            </div>
          </div>
          <div class="ts-w-1/2 ts-px-2">
            <div class="ts-w-full" v-if="subBlock.R">
              <div class="ts-flex ts--mx-2" v-for="item in subBlock.R">
                <span class="ts-whitespace-no-wrap ts-w-3/6 ts-px-2 ts-text-gray-800 ts-font-semibold ts-leading-loose">{{
                  item.dispay_name
                }}</span>
                <span class="ts-w-3/6 ts-px-2 ts-text-gray-700 ts-leading-loose">{{ item.field_value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dataFooter']
}
</script>

<style lang="scss" scoped>
.subblock-name {
  &__text {
    background-color: #fff;
    padding: 0 0;
    display: inline-block;
  }
}
</style>
